// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SoUH","largestCol":"styles_largestCol__2PfJ8","smallestCol":"styles_smallestCol__2aSjL"};